import {assert} from 'Asserts';
import {DataFrameColumnDef, DataFrameSpec} from 'data-frames/DataFrameTypes';

import findColumn, {findColumnByDisplayName} from './findColumn';

export const MISSING_SYSTEM_NAME_COLUMN_ERROR_MESSAGE =
  'Expected column to exist with systemName in data frame.';
export const MISSING_DISPLAY_NAME_COLUMN_ERROR_MESSAGE =
  'Expected column to exist with displayName in data frame.';

/**
 * Find a column definition by name in a data frame spec and throw an assertion error if it does not exist.
 */
export default function findAndAssertColumn(
  dataFrameSpec: Pick<DataFrameSpec, 'columns'>,
  columnSystemName: string
): DataFrameColumnDef {
  const column = findColumn(dataFrameSpec, columnSystemName);
  assert(column != null, MISSING_SYSTEM_NAME_COLUMN_ERROR_MESSAGE, {
    columnSystemName,
    columns: dataFrameSpec.columns,
  });

  return column;
}

export function findAndAssertColumnByDisplayName(
  dataFrameSpec: Pick<DataFrameSpec, 'columns'>,
  columnDisplayName: string
): DataFrameColumnDef {
  const column = findColumnByDisplayName(dataFrameSpec, columnDisplayName);
  assert(column != null, MISSING_DISPLAY_NAME_COLUMN_ERROR_MESSAGE, {
    columnDisplayName,
    columns: dataFrameSpec.columns,
  });

  return column;
}
